///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const StatusCheckedIcon = ({
  height,
  fill = "none",
  title = messages.status.defaultMessage,
  width,
  ...props
}) => (
  <svg
    aria-labelledby="status-checked-icon"
    height={height}
    width={width}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title id="status-checked-icon">{title}</title>
    <g clipPath="url(#statusChecked)">
      <path
        fill="#21C604"
        d="M10 1.667A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.334 14.6 18.334 10 14.6 1.667 10 1.667Zm-1.666 12.5L4.167 10l1.175-1.175 2.992 2.983 6.325-6.325 1.175 1.184-7.5 7.5Z"
      />
    </g>
    <defs>
      <clipPath id="statusChecked">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default StatusCheckedIcon;
